<template>
	<div class="fp_postcode">
		<input class="fp_postcode__input" name="postcode" :class="{'fp_postcode__input--error': toggleValidationClass}" type="text" :value="value" @input="updateValue" placeholder="Enter postcode" v-on:keyup.enter="checkPostcode()">

		<div class="firewood_prod__btn_wrap" :class="{'firewood_prod__btn_wrap--loading': loading}">
			<span class="woo_btn" @click="checkPostcode()">Check</span>

			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="35" height="35" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="translate(50,50)"><g transform="scale(0.7)"><circle cx="0" cy="0" r="50" fill="#e75000"></circle><circle cx="0" cy="-19" r="15" fill="#ffffff"><animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0 0 0;360 0 0"></animateTransform></circle></g></g></svg>
		</div>

		<span :class="{'fp_postcode__message--active': toggleValidationClass}" class="fp_postcode__message">{{ message }}</span>
	</div>
</template>

<script>
	import axios from 'axios';

	export default {
		props: {
			value: String
		},
		data: function() {
			return {
				valid: true,
				message: 'Postcode is invalid',
				loading: false
			}
		},
		watch: {
			value: function() {
				this.valid = true;
				this.message = 'Postcode is invalid';
			}
		},
		computed: {
			toggleValidationClass() {
				if (this.value != '') {
					return this.valid == true ? false : true;
				}
			}
		},
		methods: {
			updateValue(event) {
				this.$emit('input', event.target.value);
			},
			checkPostcode() {
				this.validatePostcode();

				if (this.valid) {
					this.loading = true;

					this.calcShippingBasket();

					var data = {
						postcode: this.value
					};

					const params = new URLSearchParams();
					params.append('action', 'aj_ajax_check_local');
					params.append('data', JSON.stringify(data));

					axios.post(WPURLS.ajaxurl, params)
						.then((response) => {

							if (response.data.success == true) {
								this.$emit('update:postcode_result', response.data.result);
							} else {
								this.valid = false;
								this.message = response.data.error;
							}

						})
						.catch((error) => {
							// handle error
							console.log(error);
						})
						.then(() => {
							this.loading = false;
						});
				}
			},
			validatePostcode() {
				let regex = new RegExp('^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$');
				this.valid = regex.test(this.value);
			},
			calcShippingBasket() {
				if (jQuery('.woocommerce-shipping-calculator').length > 0) {
					jQuery('.woocommerce-shipping-calculator #calc_shipping_postcode').val(this.value);
					jQuery('.woocommerce-shipping-calculator .button').click();
				}
			}
		}
	}
</script>
